module.exports = __webpack_public_path__ + "static/media/siddharth-tirupati-trip-08.ab1106cb.png";